import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MainGrid } from './Pages';

export const DashBoardRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={MainGrid} />
        
    </Fragment>
)